import React, { useState } from "react";
import MainExpenses from "./main";
import MainCategory from "./category/main";
import MainSubCategory from "./subcategory/main";
import MainDescription from "./description/main";
import MainTarget from "./Targets/main";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const TabsExpense = ({pageViewHandler}) => {
    const [viewState, setViewState] = useState('businessPlan')

   
    return (
        <>
            <div className="row fixed-top" style={{ marginTop: '0px', display: 'flex', width: '101%' }}>
            <div className="expenseBackBtn" onClick={(e) => pageViewHandler(e, 'landingPage')} >
                <ArrowBackIosNewIcon style={{ marginTop: '1px' }} />&nbsp;Back

                </div>
                <div className={`expenseTabs ${viewState === 'businessPlan'  ? "active" : ""}`} onClick={() => setViewState('businessPlan')}>
                    Business Plan

                </div>
                <div className={`expenseTabs ${viewState === 'businessReturn'  ? "active" : ""}`} onClick={() => setViewState('businessReturn')} >
                Business Return

                </div>
                <div className={`expenseTabs ${viewState === 'businessTargetcategory'  ? "active" : ""}`} onClick={() => setViewState('businessTargetcategory')} >
                Business Target Category

                </div>
                <div className={`expenseTabs ${viewState === 'businessTargetSubcategory'  ? "active" : ""}`} onClick={() => setViewState('businessTargetSubcategory')} >
                Business Target Subcategory

                </div>
                <div className={`expenseTabs ${viewState === 'businesstarget'  ? "active" : ""}`} onClick={() => setViewState('businesstarget')} >
                Business Target

                </div>

            </div>
            {/* <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4 " style={{ marginTop: window.innerWidth > 1800 ? '0%' : '5%'}}>
                        <button style={{ color: '#223d64', fontWeight: '400', display: 'flex', border: '1px solid #267dff', borderRadius: '6px', padding: '8px 10px' }} onClick={(e) => pageViewHandler(e, 'landingPage')} ><ArrowBackIosNewIcon style={{ marginTop: '1px' }} />&nbsp;Back</button>
                    </div>
                </div>
            </div> */}
            <div className="" style={{ marginTop: window.innerWidth > 1800 ? '0%' : '3%'}}>
            {viewState === 'businessPlan' ?
                <MainExpenses />
                : ""}
            {viewState === 'businessReturn' ?
                <MainCategory />
                : ""}
            {viewState === 'businessTargetcategory' ?
                <MainSubCategory />
                : ""}
            {viewState === 'businessTargetSubcategory' ?
                <MainDescription />
                : ""}
            {viewState === 'businesstarget' ?
                <MainTarget />
                : ""}
                </div>
        </>
    )
}
export default TabsExpense